import React, { useEffect, useContext, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Context_UI } from '../Contexts/Context_UI';
import Context_Provider_Accounts from '../Contexts/Context_Accounts';
import { Status_Get_All, Status_Initialize, Status_Update } from '../api/API_Status';
import { useAuth } from '../Contexts/AuthContext';
import { useStatus } from '../Contexts/Context_Status_Global';
import UI_Button from '../components/ERUMAUI/UI_Button';
import UI_Input_Text from '../components/ERUMAUI/UI_Input_Text';
import UI_Card from '../components/ERUMAUI/UI_Card';
import UI_LinearGroup from '../components/ERUMAUI/UI_LinearGroup';
import Icon_Delete from '../Assets/Icons/Icon_Delete.png';
import DR_Logo from '../Assets/Images/DR_Logo.png';


export default function DR_Main() {
    const UI = useContext(Context_UI);
    const navigate = useNavigate();
    const { Account } = useAuth();
    const [Statuses, Statuses_Set] = useState({ Modules: [] });
    const { Status_Fetching_Set } = useStatus();


    useEffect(() => {
        UI.Page_Navigator_Set(navigate);
        // UI.Initialize();
        setTimeout(function () {
            UI.LoadingScreen_Hide("Screen_Loading");
        }, 2000);
    }, []);

    useEffect(() => {
        Fetch();
    }, []);

    const Fetch = async () => {
        Status_Fetching_Set("InProgress");
        try {
            const Result = await Status_Get_All();
            if (!Result.data || Result.data.length === 0) {
                await Status_Initialize();
                const Initialized = await Status_Get_All();
                Statuses_Set(Initialized.data[0]);
                // console.log(Initialized.data[0].Modules);
            } else {
                Statuses_Set(Result.data[0]);
                // console.log(Result.data[0].Modules);
                console.warn(Result.data);
            }
        } catch (Error) {
            console.error(Error);
            Status_Fetching_Set("Error");
        }
    }

    const Add_Task = async () => {
        const Verdict = await UI.Input_Evaluate([
            { Type: "Text", ID: "Input_Module", AC: "" },
            { Type: "Text", ID: "Input_Task", AC: "" }
        ]);

        if (Verdict) {
            const Edited = {
                Module: UI.Element_Value_Get("Input_Module"),
                Task: UI.Element_Value_Get("Input_Task"),
                State: "Pending"
            };

            Statuses_Set(prev => {
                const Updated = {
                    ...prev,
                    Modules: [...prev.Modules, Edited]
                };

                const Payload = {
                    _id: "Singleton",
                    Modules: Updated.Modules,
                    LastUpdated: new Date()
                };

                (async () => {
                    // console.log("Awaiting update");
                    try {
                        await Status_Update(Payload);
                        // console.log("Success");
                    } catch (Error) {
                        console.error(Error);
                    }
                })();

                return Updated;
            });
        }
    };

    const Item_Status_Set = async (Index, Status) => {
        Statuses_Set(prev => {
            const Modules = [...prev.Modules];
            Modules[Index] = {
                ...Modules[Index],
                State: Status
            };

            const Updated = {
                ...prev,
                Modules
            };

            const Payload = {
                _id: "Singleton",
                Modules,
                LastUpdated: new Date()
            };

            (async () => {
                // console.log("Awaiting update");
                try {
                    await Status_Update(Payload);
                    // console.log("Success");
                } catch (Error) {
                    console.error(Error);
                }
            })();

            return Updated;
        });
    };

    const Item_Delete = async (index) => {
        Statuses_Set(prev => {
            const UpdatedModules = prev.Modules.filter((_, i) => i !== index);

            const Updated = {
                ...prev,
                Modules: UpdatedModules
            };

            const Payload = {
                _id: "Singleton",
                Modules: UpdatedModules,
                LastUpdated: new Date()
            };

            (async () => {
                try {
                    await Status_Update(Payload);
                    // console.log("Task deleted successfully");
                } catch (err) {
                    console.error("Error deleting task:", err);
                }
            })();

            return Updated;
        });
    };
    const Modules = Statuses?.Modules || [];
    const Total = Modules.length;
    const Completed = Modules.filter(task => task.State === "Completed").length;
    const InProgress = Modules.filter(task => task.State === "In Progress").length;
    const Pending = Modules.filter(task => task.State === "Pending").length;

    const CompletionPercent = Total === 0
        ? "0%"
        : `${Math.round((Completed / Total) * 100)}%`;




    return (
        <ui-main style={{ margin: "30px", width: "calc(100% - 60px)", height: "calc(100% - 60px)", overflowY: "auto", overflowX: "hidden" }}>
            <Context_Provider_Accounts>
                <img src={DR_Logo} style={{ width: "500px" }} />
                <h1 className='General_Title'>
                    Digi-Status (viewing as {Account?.Name_Compounded})
                </h1>
                <div style={{ display: "flex", gap: "10px", marginTop: "20px", marginBottom: "20px", flexWrap: "wrap" }}>
                    <UI_Card Shape="Rectangle" Text="Completion" Figure={CompletionPercent} />
                    <UI_Card Shape="Rectangle" Text="Total tasks" Figure={Total} />
                    <UI_Card Shape="Rectangle" Text="Completed tasks" Figure={Completed} />
                    <UI_Card Shape="Rectangle" Text="In progress tasks" Figure={InProgress} />
                    <UI_Card Shape="Rectangle" Text="Pending tasks" Figure={Pending} />
                </div>

                {Account?.isSystemAdmin ?
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr auto", gap: "10px", alignItems: "center" }}>
                        <UI_Input_Text
                            Input_Placeholder="Module"
                            id="Input_Module" />
                        <UI_Input_Text
                            Input_Placeholder="Task"
                            id="Input_Task" />
                        <UI_Button
                            Text="Add new item"
                            OnClick={Add_Task} />
                    </div>
                    :
                    ""
                }

                <>
                    {Statuses.Modules.length > 0 ?
                        <div className='ME_Table' Level="Room">
                            <div className='ME_Table_Header'>
                                <div className='ME_Table_Row'>
                                    <span></span>
                                    <p className='ME_Table_Cell'>
                                        Module
                                    </p>
                                    <p className='ME_Table_Cell'>
                                        Task
                                    </p>
                                    <p className='ME_Table_Cell'>
                                        Status
                                    </p>
                                    <p className='ME_Table_Cell'>
                                        Controls
                                    </p>
                                </div>
                            </div>
                            {Statuses.Modules.map((Item, Index) => (
                                <>
                                    <div className='ME_Table_Content'>
                                        <div className='ME_Table_Row' key={Index} State="Inactive">
                                            <p className='ME_Table_Cell'>
                                                {Index + 1}
                                            </p>
                                            <p className='ME_Table_Cell'>
                                                {Item.Module}
                                            </p>
                                            <p className='ME_Table_Cell'>
                                                {Item.Task}
                                            </p>
                                            <p className='ME_Table_Cell'>
                                                {Item.State}
                                            </p>
                                            <div className='ME_Table_Cell'>
                                                <div className='ME_Table_Controls'>
                                                    {Account?.isSystemAdmin ?
                                                        <UI_LinearGroup Direction="Row" Gap="None" Fill>
                                                            <UI_Button
                                                                Text="PD"
                                                                OnClick={() => Item_Status_Set(Index, "Pending")}
                                                            />
                                                            <UI_Button
                                                                Text="IP"
                                                                OnClick={() => Item_Status_Set(Index, "In Progress")}
                                                            />
                                                            <UI_Button
                                                                Text="CP"
                                                                OnClick={() => Item_Status_Set(Index, "Completed")}
                                                            />
                                                            <UI_Button
                                                                Icon={Icon_Delete}
                                                                Type="Icon" Icon_Position="Center"
                                                                OnClick={() => Item_Delete(Index)}
                                                            />
                                                        </UI_LinearGroup>
                                                        :
                                                        ""
                                                    }

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            ))}
                        </div>

                        :
                        <div className='ME_Table' Level="Room">
                            <div className='ME_Table_Header'>
                                <p className='ME_Table_Cell'>
                                    This section is empty.
                                </p>
                            </div>
                        </div>
                    }

                </>

            </Context_Provider_Accounts>
        </ui-main>



    )
}